import {Typography} from '@material-ui/core'
import ReportsEditSearch from 'modules/reports/components/Edit/Search'
import usePrefix from 'modules/reports/hooks/prefix'
import React from 'react'
import useStyles from './ReportsEditSection.styles'

type Props = {
  title: string
  search?: boolean
  children: React.ReactNode
  action?: React.ReactNode
  'data-testid': string
}

function ReportsEditSection(props: Props) {
  const {title, search, children, action} = props
  const classes = useStyles()
  const p = usePrefix(props['data-testid'])

  return (
    <div className={classes.root} data-testid={p()}>
      <header className={classes.header}>
        <Typography className={classes.title}>{title}</Typography>

        {action && <div className={classes.action}>{action}</div>}
      </header>

      {search && <ReportsEditSearch />}

      <div className={classes.content}>{children}</div>
    </div>
  )
}

export default ReportsEditSection
